<template>
  <div>
    <div class="d-flex justify-content-between align-items-center mb-4 mt-5">
      <h2>EMS</h2>
      <div style="width: 50%;">
        <SearchBox
          v-model="searchTerm"
          placeholder="Search clients..."
        />
      </div>
    </div>
    <AIVTable
      v-if="filteredClients && filteredClients.length"
      :columns="clientColumns"
      :data="filteredClients"
      :pagination="{ total: 0, totalPages: 0, currentPage: 0, perPage: 0 }"
    >
      <template #cell-actions="{ row }">
        <button @click="editClient(row)" class="btn btn-primary btn-sm mr-2">
          Edit
        </button>
        <button @click="removeClient(row)" class="btn btn-danger btn-sm">
          Remove
        </button>
      </template>
    </AIVTable>

    <!-- Client Modal -->
    <AIVDialog
      :visible="$modal.state.clientModal"
      :title="modalTitle"
      :show-footer="true"
      :custom-class="'client-modal'"
      @update:visible="$modal.close('clientModal')"
    >
      <!-- Edit Mode -->
      <div v-if="modal.mode === 'edit'" class="client-edit-form">
        <div class="form-group mb-3">
          <label for="clientName" class="form-label">Client Name</label>
          <input
            id="clientName"
            v-model="modal.formData.name"
            type="text"
            class="form-control"
            placeholder="Enter client name"
          />
        </div>
        <div class="form-group mb-3">
          <label for="clientTaxId" class="form-label">Tax ID</label>
          <input
            id="clientTaxId"
            v-model="modal.formData.tax_id"
            type="text"
            class="form-control"
            placeholder="Enter tax ID"
          />
        </div>
      </div>

      <!-- Remove Mode -->
      <div v-if="modal.mode === 'remove'" class="client-remove-confirm">
        <p class="text-center mb-4">
          Are you sure you want to remove the client 
          <strong>"{{ modal.selectedClient?.name }}"</strong> from this site?
        </p>
        <p class="text-muted text-center">This action cannot be undone.</p>
      </div>

      <!-- Modal Footer -->
      <template #footer>
        <div class="d-flex justify-content-around">
          <button 
            @click="closeModal" 
            class="btn btn-secondary"
          >
            Cancel
          </button>
          <button 
            v-if="modal.mode === 'edit'"
            @click="saveClient" 
            class="btn btn-primary ml-2"
          >
            Save
          </button>
          <button 
            v-if="modal.mode === 'remove'"
            @click="confirmRemoval" 
            class="btn btn-danger ml-2"
          >
            Remove
          </button>
        </div>
      </template>
    </AIVDialog>

  </div>
</template>

<script>
import SitesAPIService from "@/serviceHandlers/SitesAPIservice";
import AIVTable from "@/components/AIVTable.vue";
import SearchBox from "@/components/SearchBox.vue";

const sitesAPIService = new SitesAPIService()

export default {
  name: "EMSPage",
  components: {
    AIVTable,
    SearchBox
  },
  data(){
    return {
      searchTerm: '',
      siteData: null,
      clientColumns: [
        { key: 'name', label: 'Name' },
        { key: 'tax_id', label: 'Tin' },
        { key: 'createdAt', label: 'Created At' },
        { key: 'updatedAt', label: 'Updated At' },
        { 
          key: 'actions', 
          label: 'Actions', 
          sortable: false,
          component: 'div'
        }
      ],
      modal: {
        mode: null, // 'edit' or 'remove'
        selectedClient: null,
        formData: {
          name: '',
          tax_id: ''
        }
      }
    }
  },
  computed: {
    filteredClients() {
      if (!this.siteData || !this.siteData.clients || !this.searchTerm) {
        return this.siteData?.clients || [];
      }
      
      const searchLower = this.searchTerm.toLowerCase();
      return this.siteData.clients.filter(client => {
        const matchesName = client.name?.toLowerCase().includes(searchLower);
        const matchesTaxId = client.tax_id?.toLowerCase().includes(searchLower);
        
        return matchesName || matchesTaxId;
      });
    },
    modalTitle() {
      if (this.modal.mode === 'edit') {
        return 'Edit Client';
      } else if (this.modal.mode === 'remove') {
        return 'Remove Client';
      }
      return '';
    }
  },
  async mounted(){
    await this.getEMSData()
  },
  methods: {
    async getEMSData(){
      try {
        this.siteData = await sitesAPIService.getSiteInfo(4, this.$router)
        console.log(this.siteData)
      } catch (e) {
        console.error(e)
      }
    },
    editClient(client) {
      this.modal.selectedClient = client;
      this.modal.mode = 'edit';
      this.modal.formData.name = client.name;
      this.modal.formData.tax_id = client.tax_id;
      this.$modal.open('clientModal');
    },
    removeClient(client) {
      this.modal.selectedClient = client;
      this.modal.mode = 'remove';
      this.$modal.open('clientModal');
    },
    closeModal() {
      this.$modal.close('clientModal');
      this.modal.mode = null;
      this.modal.selectedClient = null;
      this.modal.formData.name = '';
      this.modal.formData.tax_id = '';
    },
    saveClient() {
      console.log('Saving client:', {
        id: this.modal.selectedClient.id,
        name: this.modal.formData.name,
        tax_id: this.modal.formData.tax_id
      });
      this.closeModal();
    },
    confirmRemoval() {
      console.log('Removing client:', {
        id: this.modal.selectedClient.id,
        name: this.modal.selectedClient.name
      });
      this.closeModal();
    }
  }
};
</script>

<style scoped>
/* Ensure modal is properly centered */
</style>
